<div class="g-layout__container">
    <div class="my-5">
        <h1 class="page-title" style="margin-bottom:1rem;font-weight:800;color:#333333;">{{ 'FileExplorer' | navTitle | async }}</h1>
        <div class="flex align-items-center">
            <p-dropdown ngClass="drop" (onChange)="strategyOptionsChange()" [(ngModel)]="selectedStrategyId"
                [options]="strategyOptions" optionLabel="name" optionValue="strategyId"
                placeholder="{{'select_strategy'|translate}}" />
        </div>
    </div>
    <app-file-explorer [fileElements]="(fileElements | async) ||[]" [path]="currentPath" [canNavigateUp]="canNavigateUp"
        (folderAdded)="addFolder($event)" (elementRemoved)="removeElement($event)"
        (navigatedDown)="navigateToFolder($event)" (navigatedUp)="navigateUp()" (elementRenamed)="renameElement($event)"
        (elementMoved)="moveElement($event)">
    </app-file-explorer>

</div>